import { useCallback, useEffect, useState } from 'react'
import {
  ConsentState,
  clearConsent,
  getConsent,
  setConsent,
  subscribeConsent,
  syncConsentToServer,
} from '@/lib/consent'

type UseConsentReturn = {
  consent: ConsentState | null
  hasDecided: boolean
  analyticsEnabled: boolean
  accept: () => void
  reject: () => void
  reset: () => void
}

export const useConsent = (): UseConsentReturn => {
  const [consent, setLocalConsent] = useState<ConsentState | null>(() =>
    getConsent()
  )

  useEffect(() => subscribeConsent(setLocalConsent), [])

  const accept = useCallback(() => {
    setConsent(true)
    syncConsentToServer({ force: true })
  }, [])

  const reject = useCallback(() => {
    setConsent(false)
    syncConsentToServer({ force: true })
  }, [])

  const reset = useCallback(() => {
    clearConsent()
  }, [])

  return {
    consent,
    hasDecided: consent !== null,
    analyticsEnabled: consent?.analytics === true,
    accept,
    reject,
    reset,
  }
}
